import { AnalyticsEvent, EventProps } from './general';

interface GTMEventProps extends EventProps {}

export const pushGTMEvent = (eventName: AnalyticsEvent, props: GTMEventProps) => {
    if (typeof window === 'undefined') {
        return;
    }

    if (window.dataLayer === undefined) {
        initGTM();
    }

    window.dataLayer?.push({ event: eventName, ...props });
};

const initGTM = () => {
    window.dataLayer = window.dataLayer ?? [];
};
